const navLinks = [
    { path: '/', label: 'media_gallery' },
    { path: '/documents', label: 'documents' },
];

export default navLinks;
